'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print catalogue product
 */
    .directive('capCatalogueProduct', ['productDataFinalizer', function (productDataFinalizer) {
        return {
            restrict: 'A',
            scope: {
                p: "=product"
            },
            link: function (scope, el, attr) {
                scope.hasUndefinedAvailability = function (product) {
                    return (product.productAvailability === 'undefinedAvailability');
                };

                scope.hasNoneAvailability = function (product) {
                    return (product.productAvailability === 'noneAvailability');
                };

                scope.isAvailable = function (product) {
                    return (!(scope.hasUndefinedAvailability(product) || scope.hasNoneAvailability(product)));
                };
            },
            templateUrl: "templates/catalogueproduct.html"
        }
    }]);